<template>
  <div class="blog-pagination d-flex mx-n3 pt-5 justify-content-center">
    <!-- Caso cliente queira voltar a paginação antiga  habilitar codigo comentado e arrumar estilização -->
    <!-- <button
      v-if="parameters.offset > 0"
      class="btn btn-outline-light rounded-pill pl-3 pr-4 mx-3"
      @click="$emit('prev')"
    >
      <i class="icon-chevron-left lead"></i> Mais recentes
    </button> -->

    <button
      v-if="articles.length === parameters.limit"
      class="btn btn-outline-light rounded-pill pl-4 pr-3 mx-3"
      @click="$emit('next')"
    >
      Ver Mais <i class="icon-chevron-right lead"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    articles: {
      type: Array,
      default: () => []
    },
    parameters: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
